// extracted by mini-css-extract-plugin
export var anchor = "_37-0";
export var discard = "_37-4";
export var muiTooltipTooltip = "_37-6";
export var notificationBar = "_37-3";
export var saveButtonHoverSlotWrapper = "_37-5";
export var show = "_37-2";
export var spacer = "_37-1";